import {Injectable} from '@angular/core';
import {AmplifyService} from 'aws-amplify-angular';
import {LanguageService} from './language.service';
const customData = require('../data/dogs.json');

@Injectable()
export class DogService {
  private dogItems: Map<String, DogItem> = new Map([]);
  private amplifyService: AmplifyService;
  private selectedDog: String;
  private loaded = false;

  constructor(languageService: LanguageService, amplifyService: AmplifyService) {
    this.amplifyService = amplifyService;
    this.loadDogs();
  }

  private loadDogs() {
    console.log('loading dogs ...');
    this.loaded = false;
    console.log(customData);
    this.dogItems = new Map(customData.dogs.map(i => [i.name, i]));
    this.loaded = true;
    console.log('... finished loading dogs');

  }


  public isLoaded(): boolean {
    return this.loaded;
  }

  public getDogNames(): Iterable<String> {
    return Array.from(this.dogItems.keys());
  }

  public getDogs(): Iterable<DogItem> {
    return Array.from(this.dogItems.values());
  }

  public getCurrentDogs(): Iterable<DogItem> {
    return Array.from(this.dogItems.values()).filter((dog) => dog.category === 'current');
  }

  public getPreviousDogs(): Iterable<DogItem> {
    return Array.from(this.dogItems.values()).filter((dog) => dog.category === 'previous');
  }

  public select(selectedDog: String) {
    this.selectedDog = selectedDog;
    console.log('selected dog = ' + this.getSelectedDog().name);
  }

  public deselect() {
    this.selectedDog = null;
  }

  public getSelectedDog(): DogItem {
    if (this.selectedDog) {
      return this.dogItems.get(this.selectedDog);
    } else {
      return null;
    }
  }

  public getPedigree(): Pedigree {
    const pedigree: Pedigree = new Pedigree();
    const selected: DogItem = this.dogItems.get(this.selectedDog);
    if (this.dogItems.get(selected.sire)) {
      pedigree.sire = this.dogItems.get(selected.sire);
      if (this.dogItems.get(pedigree.sire.sire)) {
        pedigree.sire_sire = this.dogItems.get(pedigree.sire.sire);
      }
      if (this.dogItems.get(pedigree.sire.dame)) {
        pedigree.sire_dame = this.dogItems.get(pedigree.sire.dame);
      }
    }
    if (this.dogItems.get(selected.dame)) {
      pedigree.dame = this.dogItems.get(selected.dame);
      if (this.dogItems.get(pedigree.dame.sire)) {
        pedigree.dame_sire = this.dogItems.get(pedigree.dame.sire);
      }
      if (this.dogItems.get(pedigree.dame.dame)) {
        pedigree.dame_dame = this.dogItems.get(pedigree.dame.dame);
      }
    }

    return pedigree;
  }

}

export class DogItem {
  name: String;
  gender: String;
  category: String;
  icon: String = '/assets/images/dogs/faye.jpg';
  image: String;
  comments: String;
  losh: String;
  birthDate: String;
  sire: String;
  dame: String;
  pedigreeId: String;
}

export class Pedigree {
  sire: DogItem;
  dame: DogItem;
  sire_sire: DogItem;
  sire_dame: DogItem;
  dame_sire: DogItem;
  dame_dame: DogItem;
}
